import { QueryClient } from "@tanstack/react-query";
import {
  createRootRouteWithContext,
  ErrorComponentProps,
  Outlet,
} from "@tanstack/react-router";
import { useEffect } from "react";

import {
  isChunkLoadError,
  recoverFromChunkLoadError,
  reloadApplication,
} from "../../shared/lib/chunk-load-recovery";

import { getErrorTextByError } from "../../shared/lib/get-error-text-by-error";

interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Outlet,
  errorComponent: RootErrorComponent,
});

function RootErrorComponent({ error, reset }: ErrorComponentProps) {
  const shouldReloadApplication = isChunkLoadError(error);

  useEffect(() => {
    if (shouldReloadApplication) {
      recoverFromChunkLoadError();
    }
  }, [shouldReloadApplication]);

  return (
    <main
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        padding: 24,
        background: "#f5f6fa",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 480,
          padding: 24,
          borderRadius: 24,
          background: "#fff",
          boxShadow: "0 16px 48px rgba(17, 24, 39, 0.08)",
        }}
      >
        <h1 style={{ margin: 0, fontSize: 24 }}>Что-то пошло не так</h1>
        <p style={{ margin: "12px 0 0", color: "#4b5563", lineHeight: 1.5 }}>
          {shouldReloadApplication
            ? "Приложение обновилось на сервере. Перезагрузите страницу, чтобы загрузить актуальную версию."
            : getErrorTextByError(error) ??
              "Не удалось открыть страницу. Попробуйте ещё раз."}
        </p>
        <button
          type="button"
          onClick={shouldReloadApplication ? reloadApplication : reset}
          style={{
            marginTop: 20,
            padding: "12px 16px",
            border: 0,
            borderRadius: 12,
            background: "#111827",
            color: "#fff",
            cursor: "pointer",
          }}
        >
          {shouldReloadApplication ? "Обновить приложение" : "Повторить"}
        </button>
      </div>
    </main>
  );
}
